enum ElectronicClientRecordResuscitationDecisionType {
  No = 'No',
  Yes = 'Yes',
  Unknown = 'Unknown',
}

export default ElectronicClientRecordResuscitationDecisionType;
